module.exports = __webpack_public_path__ + "static/media/ihab.87e124c9.png";